import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum"
export default class ParamsGetSolicitud {
    constructor(
        public tipoBeneficio?: TipoBeneficioEnum,
        public numeroSolicitud?: number
    ) {}
}